<template>
  <div>
    <vue-easy-lightbox
      escDisabled
      moveDisabled
      :visible="visible"
      :imgs="images"
      :index="index"
      @hide="handleHide"
    ></vue-easy-lightbox>
    <a-tabs v-model="mainTab" class="px-2 feed-page-tabs" :animated="false">
      <a-tab-pane key="news" :tab="$t('activityClub.tabNews')">
    <div class="feed-wrapper feed-viewport-lock">
      <div class="feed-layout">
        <!-- Left: Filters -->
        <aside class="feed-sidebar">
          <actuality-filters
            @filter-change="handleFilterChange"
            ref="filtersRef"
            :studentList="studentList"
            :classes="classes"
            :teacherList="teacherList"
            :activitiesList="activitiesList"
            :totalItems="totalItems"
          />
        </aside>

        <!-- Right: Composer + Feed -->
        <main class="feed-main">
          <div class="feed-scroll">
          <!-- Global Comments Toggle -->
          <div class="comments-toggle-section">
            <div class="comments-toggle-row">
              <span class="toggle-icon"><a-icon type="message" /></span>
              <span class="toggle-label">{{ $t("actualite.enableComments") }}</span>
              <a-switch
                v-model="enableNewsComments"
                @change="handleCommentsToggle"
                :checked="enableNewsComments"
              />
            </div>
            <div class="toggle-hint">
              {{ enableNewsComments
                ? ($t("actualite.commentsEnabled"))
                : ($t("actualite.commentsDisabled")) }}
            </div>
          </div>

          <actuality-composer
            :logo="logo"
            @add-news="showActualityModal(1)"
            @add-album="showActualityModal(2)"
          />

          <div class="feed-body">
            <template v-if="loading">
              <div v-for="n in 3" :key="n" class="post-card skeleton-card">
                <div class="sk-header">
                  <div class="sk-avatar sk-pulse"></div>
                  <div class="sk-header-meta">
                    <div class="sk-line sk-title sk-pulse"></div>
                    <div class="sk-line sk-date sk-pulse"></div>
                  </div>
                  <div class="sk-options sk-pulse"></div>
                </div>
                <div class="sk-tags">
                  <div class="sk-chip sk-pulse"></div>
                  <div class="sk-chip sk-pulse short"></div>
                </div>
                <div class="sk-content">
                  <div class="sk-line sk-pulse"></div>
                  <div class="sk-line sk-pulse"></div>
                  <div class="sk-line sk-pulse short"></div>
                </div>
                <div class="sk-media sk-pulse"></div>
                <div class="sk-stats">
                  <div class="sk-line sk-pulse tiny"></div>
                  <div class="sk-line sk-pulse tiny"></div>
                </div>
                <div class="sk-actions">
                  <div class="sk-action sk-pulse"></div>
                  <div class="sk-action sk-pulse"></div>
                </div>
              </div>
            </template>
            <template v-else>
              <div v-if="data && data.length === 0" class="text-center empty-state">
                <a-empty :description="$t('actualite.aucuneActualite')" />
              </div>
              <transition-group name="post-fade" tag="div" class="posts-list" appear>
                <actuality-post-card
                  v-for="(item, index) in data"
                  :key="item._id"
                  :item="item"
                  :index="index"
                  :logo="logo"
                  :school-name="schoolName"
                  :settings="settings"
                  :emojis="emojis"
                  @edit="(post) => showActualityModal(post.category === 'album' ? 2 : 1, post)"
                  @approve="(id) => confirmAction('approve', id)"
                  @reject="(id) => confirmAction('reject', id)"
                  @delete="(id) => confirmAction('delete', id)"
                  @show-image="show"
                  @like="submitLike"
                  @unlike="submitUnLike"
                  @toggle-comment="toggleComment"
                  @submit-comment="submitComment"
                  @delete-comment="deleteComment"
                />
              </transition-group>
        </template>
          </div>
          <div class="feed-pagination" v-if="totalItems > 0">
            <a-pagination
              v-model="currentPage"
              :total="totalItems"
              :pageSize="pageSize"
              @change="handlePageChange"
            />
          </div>
          </div>
        </main>
      </div>
    </div>
    <actuality-form
      ref="actualityFormRef"
      :enableNewsComments="enableNewsComments"
      :studentList="studentList"
      :classes="classes"
      :teacherList="teacherList"
      :activitiesList="activitiesList"
      @newsUpdated="getActuality()"
    />
      </a-tab-pane>
      <a-tab-pane key="club" :tab="$t('activityClub.tabClub')">
        <activity-club-index
          :studentList="studentList"
          :classes="classes"
          :teacherList="teacherList"
          :activitiesList="activitiesList"
        />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
/* eslint-disable */
import apiClient from "@/services/axios";
import actualityForm from "./components/actualityForm.vue";
import actualityFilters from "./components/ActualityFilters.vue";
import ActualityComposer from "./components/ActualityComposer.vue";
import ActualityPostCard from "./components/ActualityPostCard.vue";
import ActivityClubIndex from "./activityClub/ActivityClubIndex.vue";
import { mapState } from "vuex";
var publicationData = [];
export default {
  components: {
    actualityForm,
    actualityFilters,
    ActualityComposer,
    ActualityPostCard,
    ActivityClubIndex,
  },
  name: "publications",

  data() {
    return {
      loading: true,
      cacheData: null,
      data: null,
      visible: false,
      images: [],
      index: 0,
      emojis: [],
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      enableNewsComments: true, // Global toggle for comments
      filterParams: {},
      // Shared data for filters and form
      studentList: [],
      classes: [],
      teacherList: [],
      activitiesList: [],
      mainTab: "news",
    };
  },

  computed: {
    ...mapState(["settings", "user"]),
    activeBuildingImage() {
      const images = this.settings?.image;
      if (!Array.isArray(images) || !images.length) return null;
      return (
        images.find((img) => img.db === this.settings.activeBuilding) ||
        images[0] ||
        null
      );
    },
    logo() {
      return this.activeBuildingImage?.logo || null;
    },
    schoolName() {
      return this.activeBuildingImage?.name || "";
    },
  },

  async created() {
    this.loadCommentsSetting();
    this.loadSharedData();
    this.getActuality();
    fetch("/emojis.json")
      .then((res) => res.json())
      .then((data) => (this.emojis = data));
  },

  mounted() {
    this.$nextTick(() => {
      requestAnimationFrame(() => this.startFeedLock());
    });
  },

  beforeDestroy() {
    this.stopFeedLock();
  },

  watch: {
    mainTab() {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => this.startFeedLock());
        });
      });
    },
    // Watch for changes in the building data from store
    "user.building": {
      handler() {
        this.loadCommentsSetting();
      },
      deep: true,
    },
    // Watch for active building changes
    "settings.activeBuilding"() {
      this.loadCommentsSetting();
    },
  },

  methods: {
    isFeedMobile() {
      return window.matchMedia("(max-width: 991px)").matches;
    },
    findVisibleFeedWrapper() {
      const activePane = this.$el.querySelector(".ant-tabs-tabpane-active");
      if (activePane) {
        const inPane = activePane.querySelector(".feed-wrapper");
        if (inPane) return inPane;
      }
      const wrappers = Array.from(this.$el.querySelectorAll(".feed-wrapper"));
      return wrappers[0] || null;
    },
    applyFeedLockHeight(wrapperEl) {
      const wrappers = Array.from(this.$el.querySelectorAll(".feed-wrapper"));
      if (this.isFeedMobile()) {
        wrappers.forEach((el) => el.style.removeProperty("--feed-lock-height"));
        return;
      }
      const measureEl = wrapperEl || wrappers[0];
      if (!measureEl) return;
      const top = measureEl.getBoundingClientRect().top;
      if (top <= 0) return;
      const height = Math.max(280, Math.floor(window.innerHeight - top - 16));
      wrappers.forEach((el) => {
        el.style.setProperty("--feed-lock-height", `${height}px`);
      });
    },
    onFeedLockResize() {
      this.applyFeedLockHeight(this._feedLockWrapper);
    },
    onFeedLockWheel(event) {
      if (this.isFeedMobile() || event.ctrlKey || !this._feedLockWrapper) return;
      const wrapper = this._feedLockWrapper;
      const main = wrapper.querySelector(".feed-scroll") || wrapper.querySelector(".feed-main");
      const sidebar = wrapper.querySelector(".feed-sidebar");
      if (!main) return;
      if (main.contains(event.target)) return;
      if (
        sidebar &&
        sidebar.contains(event.target) &&
        sidebar.scrollHeight > sidebar.clientHeight + 1
      ) {
        return;
      }
      const prev = main.scrollTop;
      main.scrollTop += event.deltaY;
      if (main.scrollTop !== prev) {
        event.preventDefault();
      }
    },
    startFeedLock() {
      this.stopFeedLock();
      const wrapper = this.findVisibleFeedWrapper();
      if (!wrapper) return;
      this._feedLockWrapper = wrapper;
      this.applyFeedLockHeight(wrapper);
      if (!this.isFeedMobile()) {
        document.body.classList.add("actuality-feed-lock");
      }
      window.addEventListener("resize", this.onFeedLockResize);
      wrapper.addEventListener("wheel", this.onFeedLockWheel, { passive: false });
      if (typeof ResizeObserver !== "undefined") {
        this._feedLockObserver = new ResizeObserver(this.onFeedLockResize);
        this._feedLockObserver.observe(wrapper);
      }
    },
    stopFeedLock() {
      const wrapper = this._feedLockWrapper;
      window.removeEventListener("resize", this.onFeedLockResize);
      if (wrapper) {
        wrapper.removeEventListener("wheel", this.onFeedLockWheel);
        wrapper.style.removeProperty("--feed-lock-height");
      }
      if (this._feedLockObserver) {
        this._feedLockObserver.disconnect();
        this._feedLockObserver = null;
      }
      document.body.classList.remove("actuality-feed-lock");
      this._feedLockWrapper = null;
    },
    async handleCommentsToggle(checked) {
      try {
        await apiClient.patch("/actuality/settings/comments", {
          enableNewsComments: checked,
        });
        this.enableNewsComments = checked;

        await this.getActuality();

        this.$message.success(
          this.$t("success.changementEffectue")
        );
      } catch (error) {
        this.enableNewsComments = !checked; // Revert the toggle
        this.$message.error(
          this.$t("error.unexpectedError")
        );
      }
    },

    loadCommentsSetting() {
      // Get building from user store
      const building = this.user?.building?.filter(
        (el) => el.dbName == this.settings.activeBuilding
      )[0];

      // Set enableNewsComments from building data if available
      if (building && building.enableNewsComments !== undefined) {
        this.enableNewsComments = building.enableNewsComments;
      }
    },

    async getActuality() {
      this.loading = true;

      // Build query params with pagination and filters
      const params = {
        page: this.currentPage,
        limit: this.pageSize,
        ...this.filterParams,
      };

      await apiClient
        .get("/actuality/find", { params })
        .then(({ data }) => {
          // Extract data and pagination info from response
          const actualities = data.data || [];
          const pagination = data.pagination || {};
          const selectedCategory = this.filterParams?.category;
          const predefinedLegacyCategoryMap = {
            info: ["info", "إعلام", "Information"],
            important_info: ["important_info", "إعلام هام", "Important information"],
            urgent: ["urgent", "عاجل", "Urgent"],
            avis_important: ["avis_important", "Avis important", "Important notice"],
            avis: ["avis", "Avis", "Notice"],
            important: ["important", "Important", "مهم"],
          };

          let filteredActualities = actualities;
          if (selectedCategory) {
            if (selectedCategory === "actualite") {
              filteredActualities = actualities.filter(
                (item) => item.category !== "album"
              );
            } else if (selectedCategory === "album") {
              filteredActualities = actualities.filter(
                (item) => item.category === "album"
              );
            } else {
              const allowedCategories =
                predefinedLegacyCategoryMap[selectedCategory] || [selectedCategory];
              filteredActualities = actualities.filter((item) =>
                allowedCategories.includes(item.category)
              );
            }
          }

          publicationData = [...filteredActualities];
          publicationData = publicationData.map((item) => {
            return {
              ...item,
              processing: false,
              showComments: true,
              emojis: false,
            };
          });
          this.data = publicationData;
          this.cacheData = publicationData.map((item) => ({ ...item }));
          this.totalItems = selectedCategory
            ? publicationData.length
            : pagination.totalItems || 0;
          this.loading = false;
        })
        .catch((e) => {
          console.log(e);
          this.$message.error(this.$t("error.aucActualite"));
          this.loading = false;
        });
    },

    async validateNews(id) {
      try {
        await apiClient.patch("/actuality/" + id + "/validation-status", {
          validationStatus: "validated",
        });
        this.$message.success(this.$t("actualite.newsValidated"));
        await this.getActuality();
      } catch (error) {
        console.error(error);
        this.$message.error(this.$t("error.unexpectedError"));
      }
    },

    async rejectNews(id) {
      try {
        await apiClient.patch("/actuality/" + id + "/validation-status", {
          validationStatus: "rejected",
        });
        this.$message.success(this.$t("actualite.newsRejected"));
        await this.getActuality();
      } catch (error) {
        console.error(error);
        this.$message.error(this.$t("error.unexpectedError"));
      }
    },

    confirmAction(action, id) {
      const titleMap = {
        approve: this.$t("actualite.approve") + "?",
        reject: this.$t("actualite.confirmReject"),
        delete: this.$t("requis.supp"),
      };
      this.$confirm({
        title: titleMap[action],
        okText: this.$t("all.okay"),
        cancelText: this.$t("all.cancel"),
        onOk: () => {
          if (action === "approve") return this.validateNews(id);
          if (action === "reject") return this.rejectNews(id);
          if (action === "delete") return this.supp(id);
        },
      });
    },

    supp(key) {
      apiClient
        .delete("/actuality/" + key)
        .then(() => {
          this.$message.success(this.$t("success.pubSupp"));
          const dataSource = [...this.data];
          this.data = dataSource.filter((item) => item._id !== key);
        })
        .catch(() => this.$message.error(this.$t("success.autorisationSupp")));
    },

    submitLike(actualityId, actualityIndex) {
      this.data[actualityIndex].processing = true;
      this.data[actualityIndex].liked = true;
      this.data[actualityIndex].total_likes++;

      const request = {
        type: "Admin",
        actuality: actualityId,
        fullName: this.$store.state.user.userName,
      };
      apiClient
        .post("/actuality/like", { ...request })
        .then(async ({ data }) => {
          //this.getActuality();
        })
        .catch((e) => {
          console.log(e);
          this.data[actualityIndex].liked = false;
          this.data[actualityIndex].total_likes--;
        })
        .finally(() => (this.data[actualityIndex].processing = false));
    },

    async submitUnLike(actualityId, actualityIndex) {
      this.data[actualityIndex].processing = true;
      this.data[actualityIndex].liked = false;
      this.data[actualityIndex].total_likes--;
      let data = {
        type: "Admin",
      };
      await apiClient
        .delete("/actuality/like/remove/" + actualityId, { data })
        .then(async ({ data }) => {
          //await this.getActuality();
        })
        .catch((e) => {
          console.log(e);
          this.data[actualityIndex].liked = true;
          this.data[actualityIndex].total_likes++;
        })
        .finally(() => (this.data[actualityIndex].processing = false));
    },

    async submitComment(comment, actualityId) {
      if (comment == "" || comment == " " || !comment) return;
      const request = {
        desc: comment,
        actuality: actualityId,
        type: "Admin",
        fullName: this.$store.state.user.userName,
      };
      try {
        const { data } = await apiClient.post("/actuality/comment", { ...request });
        const postIndex = this.data.findIndex((item) => item._id === actualityId);
        if (postIndex === -1) return;

        const created =
          (data && (data.entity || data.comment)) || {
            _id: Date.now().toString(),
            desc: comment,
            type: "Admin",
            fullName: this.$store.state.user.userName,
            createdAt: new Date().toISOString(),
          };

        if (!Array.isArray(this.data[postIndex].comments)) {
          this.$set(this.data[postIndex], "comments", []);
        }
        this.data[postIndex].comments.push(created);
      } catch (e) {
        this.$message.error(this.$t("error.unexpectedError"));
      }
    },

    async deleteComment(commentId, actualityIndex) {
      const post = this.data[actualityIndex];
      if (!post) return;

      const previousComments = [...(post.comments || [])];
      post.comments = previousComments.filter((c) => c._id !== commentId);

      try {
        await apiClient.delete("/actuality/comment/" + commentId);
      } catch (e) {
        this.$set(this.data[actualityIndex], "comments", previousComments);
        this.$message.error(this.$t("error.unexpectedError"));
      }
    },

    show(images, index) {
      const currentFile = images[index];
      if (this.isImageFile(currentFile)) {
        const imageFiles = images.filter((img) => this.isImageFile(img));
        this.images = imageFiles.map((img) =>
          this.settings.resourcesUrl.replace("FILE_PATH", img)
        );
        this.index = imageFiles.indexOf(currentFile);
        this.visible = true;
      } else {
        // Open document in new window
        window.open(
          this.settings.resourcesUrl.replace("FILE_PATH", currentFile),
          "_blank"
        );
      }
    },

    handleHide() {
      this.visible = false;
    },

    toggleComment(actualityIndex) {
      this.data[actualityIndex].showComments =
        !this.data[actualityIndex].showComments;
    },

    showActualityModal(type, item = null) {
      this.$refs.actualityFormRef.showActualityModal(type, item);
    },

    isImageFile(file) {
      const ext = file.split(".").pop().toLowerCase();
      return ["jpg", "jpeg", "png"].includes(ext);
    },

    handlePageChange(page) {
      this.currentPage = page;
      this.scrollFeedToTop();
      this.getActuality().then(() => {
        this.$nextTick(() => this.scrollFeedToTop());
      });
    },

    handleFilterChange(filterParams) {
      this.currentPage = 1;
      this.filterParams = filterParams;
      this.scrollFeedToTop();
      this.getActuality().then(() => {
        this.$nextTick(() => this.scrollFeedToTop());
      });
    },

    scrollFeedToTop() {
      const wrapper = this._feedLockWrapper || this.findVisibleFeedWrapper();
      const main = wrapper && wrapper.querySelector(".feed-scroll");
      if (main) main.scrollTop = 0;
    },

    async loadSharedData() {
      try {
        const [studentsRes, classroomsRes, teachersRes, activitiesRes] = await Promise.all([
          apiClient.post("/students/filter", {
            query: { status: "active" },
          }),
          apiClient.post("/classrooms/filter", {
            query: { status: "active" },
            aggregation: {
              $project: { _id: 1, name: 1 },
            },
          }),
          apiClient.post("/teachers/filter", {
            query: { status: "active" },
            aggregation: {
              $project: { _id: 1, employee: 1 },
            },
          }),
          apiClient.post("/activities/filter", {
            query: { status: "active" },
          }),
        ]);

        this.studentList = studentsRes.data;
        this.classes = classroomsRes.data;
        this.teacherList = teachersRes.data;
        this.activitiesList = activitiesRes.data;
      } catch (error) {
        console.error("Error loading shared data:", error);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/components/mixins.scss";
@import "./components/feed-shared.scss";

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Ant Design tabs use overflow:hidden, which blocks position:sticky on the filter bar */
.feed-page-tabs {
  overflow: visible !important;

  :deep(.ant-tabs-content) {
    overflow: visible !important;
  }

  :deep(.ant-tabs-tabpane-active) {
    overflow: visible !important;
  }

  :deep(.ant-tabs-tabpane-inactive) {
    overflow: hidden !important;
    height: 0;
  }
}
</style>

<style lang="scss">
body.actuality-feed-lock {
  overflow: hidden;
}
</style>

